import * as types from '../types/language.types';

const initialState = {
  language: 'en',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_APP_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };

    default:
      return state;
  }
};
